import React from "react";
import Select from "react-select";
import Tooltip from "../../../Common/Tooltip";
import { OIB, ibanNum, address, numbersOnly } from "../../../../Config/Regex";
import { validationService } from "../../../../Services/validation.service";
import { Controller, useForm } from "react-hook-form";
import { FORM_FIELDS } from "../../Constants";
import Stepper from "../../components/Stepper";
import ErrorMessage from "../../components/ErrorMessage";
import useFetcher from "../../../../Hooks/useFetcher";
import { globalServices } from "../../../../Services";
import { Link } from "react-router-dom";

const ClientData = ({ stepState, previousPage, nextPage, formData }) => {
  const { CLIENT_DATA } = FORM_FIELDS;

  const { data: postOffices } = useFetcher({
    fetcher: globalServices.getPostOffices,
  });

  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: formData[CLIENT_DATA.name],
  });

  const setCity = (id) => {
    globalServices.getCityByPostOffice(id).then((res) => {
      setValue(CLIENT_DATA.CITY.name, res?.data?.data?.name, {
        shouldValidate: true,
      });
    });
  };

  const onNextPage = (data) => {
    nextPage({
      [CLIENT_DATA.name]: data,
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">Matični podaci</legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="taxNumber">
                  {CLIENT_DATA.OIB.title} <b>*</b>
                </label>
                <Tooltip text="Unesite 11-znamenkasti OIB vaše tvrkte/obrta" />
                <input
                  className="form-control"
                  type="text"
                  name={CLIENT_DATA.OIB.name}
                  ref={register({
                    required: true,
                    pattern: OIB,
                    validate: () =>
                      validationService.validateTenantOib(
                        document.getElementsByName(CLIENT_DATA.OIB.name)[0]
                          .value
                      ),
                  })}
                  // defaultValue={createTenantData.taxNumber}
                />
                <ErrorMessage
                  errorType={errors?.[CLIENT_DATA.OIB.name]?.type}
                  messages={{
                    required: "Oib je obavezan!!",
                    pattern: "OIB mora sadržavati točno 11 znamenki!",
                  }}
                />

                {errors?.[CLIENT_DATA.OIB.name]?.type === "validate" && (
                  <div className="invalid-record my-3 p-3">
                    <p className="m-0">
                      OIB nije važeći ili je već u upotrebi!
                    </p>
                    <Link to="/public/onboarding-existing">
                      Ažurirajte postojećeg klijenta?
                    </Link>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="tenantName">
                  {CLIENT_DATA.NAME.title} <b>*</b>
                </label>{" "}
                <Tooltip text="Moguć je unos do 250 znakova (kombinacija slova, brojeva i posebnih znakova)." />
                <input
                  type="text"
                  className="form-control"
                  name={CLIENT_DATA.NAME.name}
                  ref={register({ required: true, maxLength: 250 })}
                  // defaultValue={createTenantData.name}
                />
                <ErrorMessage
                  errorType={errors?.[CLIENT_DATA.NAME.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    maxLength: "Moguće je unijeti maksimalno 250 znakova!",
                  }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="iban">{CLIENT_DATA.IBAN.title}</label>{" "}
                <Tooltip text="Unesite IBAN vaše tvrtke/obrta bez razmaka i posebnih znakova" />
                <div class="input-group mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      HR
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name={CLIENT_DATA.IBAN.name}
                    ref={register({
                      pattern: ibanNum,
                    })}
                    //   defaultValue={createTenantData.iban.substring(2)}
                  />
                </div>
                <ErrorMessage
                  errorType={errors?.[CLIENT_DATA.IBAN.name]?.type}
                  messages={{
                    pattern: "IBAN mora sadržavati točno 19 znamenki!",
                  }}
                />
              </div>

              {/* Porezna obaveza */}
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name={CLIENT_DATA.FISCAL_OBLIGATION.name}
                    ref={register}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{CLIENT_DATA.FISCAL_OBLIGATION.title}</span>
                {/* <Tooltip text="Ukoliko nema porezne obveze, portebno je odznačiti ovo polje. U slučaju promjene u poreznoj obvezi, polje je moguće naknadno ažurirati." /> */}
              </div>

              {/* Porezna obaveza */}
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name={CLIENT_DATA.TAX_OBLIGATION.name}
                    ref={register}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{CLIENT_DATA.TAX_OBLIGATION.title}</span>
                <Tooltip text="Ukoliko nema porezne obveze, portebno je odznačiti ovo polje. U slučaju promjene u poreznoj obvezi, polje je moguće naknadno ažurirati." />
              </div>

              {/* Porezna bilješka */}
              <div className="form-group">
                <label htmlFor="taxObligation">
                  {CLIENT_DATA.TAX_NOTE.title}
                </label>{" "}
                <Tooltip text="Polje za unos teksta koji se treba ispisati na računu zbog zakonske obveze. Npr. Oslobođen od PDV-a temeljem članka xy, zakona o xyz." />
                <input
                  type="text"
                  className="form-control"
                  name={CLIENT_DATA.TAX_NOTE.name}
                  ref={register({ maxLength: 250 })}
                />
                <ErrorMessage
                  errorType={errors?.[CLIENT_DATA.TAX_NOTE.name]?.type}
                  messages={{
                    maxLength: "Moguće je unijeti maksimalno 250 znakova!",
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-6">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">Podaci o adresi</legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="street">
                  {CLIENT_DATA.STREET.title}
                  <b>*</b>
                </label>{" "}
                <Tooltip text="Unesite puni naziv registrirane adrese sjedišta tvrtke/obrta. Adresa sjedišta će se ispisivati na svakom računu." />
                <input
                  type="text"
                  className="form-control"
                  name={CLIENT_DATA.STREET.name}
                  ref={register({
                    required: true,
                    pattern: address,
                    maxLength: 150,
                  })}
                  // defaultValue={createTenantData.street}
                />
                <ErrorMessage
                  errorType={errors?.[CLIENT_DATA.STREET.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    pattern:
                      "Dopušten je samo tekstualni unos, brojevi i točka!",
                    maxLength: "Moguće je unijeti maksimalno 250 znakova!",
                  }}
                />
              </div>

              <div className="form-row">
                <div className="form-group col-md-8">
                  <label htmlFor="streetNumber">
                    {CLIENT_DATA.STREET_NUMBER.title}
                    <b>*</b>
                  </label>{" "}
                  <Tooltip
                    text={
                      "Kućni broj koji se određuje u svrhu lociranja zgrade u prostoru, te evidentiranja zgrade u adresnom sustavu. Kućni broj treba biti isključivo brojčana vrijednost. Ako imate oznaku 'bez broja' u kućni broj možete upisati približnu vrijednost ili vrijednost 0, a 'bb' potom upisati u polje Dodatak. Ako kućni broj ima kombinaciju brojki i slova npr. 38A, u polje Kućni broj unesite samo brojku (npr. 38), a u polje Dodatak unesite slovo (npr. A)."
                    }
                  />
                  <input
                    type="text"
                    className="form-control"
                    name={CLIENT_DATA.STREET_NUMBER.name}
                    ref={register({
                      required: true,
                      pattern: numbersOnly,
                      maxLength: 6,
                    })}
                  />
                  <ErrorMessage
                    errorType={errors?.[CLIENT_DATA.STREET_NUMBER.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                      maxLength: "Moguće je unijeti maksimalno 6 znakova!",
                      pattern: "Molimo unesite samo brojeve!",
                    }}
                  />
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="streetNumberExtension">
                    {CLIENT_DATA.STREET_NUMBER_EXTENSTION.title}
                  </label>{" "}
                  <Tooltip
                    text={
                      "Ako kućni broj ima dodatak, npr. Naziv ulice 38 A ili ako nema kućnog broja unosi se 'bb' (bez broja)."
                    }
                  />
                  <input
                    type="text"
                    className="form-control"
                    name={CLIENT_DATA.STREET_NUMBER_EXTENSTION.name}
                    ref={register({ maxLength: 10 })}
                  />
                  <ErrorMessage
                    errorType={
                      errors?.[CLIENT_DATA.STREET_NUMBER_EXTENSTION.name]?.type
                    }
                    messages={{
                      maxLength: "Moguće je unijeti maksimalno 10 znakova!",
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-lg-6 m-0">
                  <label htmlFor="postalNumber">
                    {CLIENT_DATA.POSTAL_NUMBER.title}
                    <b>*</b>
                  </label>{" "}
                  <Tooltip
                    text={
                      "Odabir poštanskog broja za pripadajući grad, kombinacija brojeva kako bi se omogućilo brzo strojno razvrstavanje pošiljki."
                    }
                  />
                  <Controller
                    as={Select}
                    options={(postOffices?.data || []).map((x) => ({
                      id: x.id,
                      label: x.name,
                      value: x.name,
                    }))}
                    name={CLIENT_DATA.POSTAL_NUMBER.name}
                    control={control}
                    rules={{ required: true }}
                    onChange={function (event) {
                      setCity(event[0].id);
                      return event[0];
                    }}
                  />
                  <ErrorMessage
                    errorType={errors?.[CLIENT_DATA.POSTAL_NUMBER.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                    }}
                  />
                </div>

                <div className="form-group col-lg-6 m-0">
                  <label htmlFor="city">
                    {CLIENT_DATA.CITY.title}
                    <b>*</b>
                  </label>{" "}
                  <Tooltip text={"Naziv grada"} />
                  <input
                    type="text"
                    className="form-control"
                    name={CLIENT_DATA.CITY.name}
                    ref={register({ required: true })}
                  />
                  <ErrorMessage
                    errorType={errors?.[CLIENT_DATA.CITY.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                    }}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <Stepper
        stepState={stepState}
        previousPage={previousPage}
        nextPage={handleSubmit(onNextPage)}
      />
    </>
  );
};

export default ClientData;
